
import Overlay from '@/components/Overlay.vue';
import NoAccess from '@/components/NoAccess.vue';
import { PieChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers';
import { defineComponent, reactive, toRefs } from 'vue';
import VChart from 'vue-echarts';
import filters from '@/common/filters';

use([
  PieChart,
  CanvasRenderer,
  SVGRenderer,
  GridComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
]);

export default defineComponent({
  name: 'DashboardTargetAccomplished',

  components: {
    VChart,
    Overlay,
    NoAccess,
  },

  props: {
    salesChannelName: {
      type: String,
      default: '',
    },
    targetAccomplished: {
      type: Object,
      default: () => ({}),
    },

    loading: {
      type: Boolean,
      default: false,
    },

    access: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    setOptionsChart() {
      const colorBalance =
        this.targetAccomplished.channelBalanceValue > 0 ? '#219653' : '#e70024';
      (this.$refs['chart'] as any).setOption({
        series: [
          {
            cursor: 'normal',
            name: 'Access From',
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['80%', '95%'],
            emphasis: {
              series: 'none',
            },
            label: {
              show: true,
              position: 'center',
              formatter: () => {
                return `{text|Orçamento} \n {value| R$ ${this.targetAccomplished?.channelBudgetValue?.toLocaleString(
                  'pt-BR'
                )}}`;
              },
              rich: {
                text: {
                  align: 'center',
                  fontSize: filters.isMobile() ? 14 : 18,
                  padding: [0, 0, 10, 0],
                },
                value: {
                  align: 'center',
                  fontSize: filters.isMobile() ? 10 : 14,
                  fontWeight: 'bold',
                },
              },
            },
            data: [
              {
                value: this.targetAccomplished.channelRevenueValue,
                itemStyle: { color: '#ff9050' },
              },
              {
                value: this.targetAccomplished.channelBalanceValue
                  .toString()
                  .replace('-', ''),
                itemStyle: { color: colorBalance },
              },
              {
                value: this.targetAccomplished.channelInvoiceValue,
                itemStyle: { color: '#ffd337' },
              },
            ],
          },
        ],
      });
    },
  },

  watch: {
    targetAccomplished: {
      handler() {
        this.setOptionsChart();
      },
      deep: true,
    },
  },

  setup() {
    const state = reactive({
      options: {
        series: [
          {
            cursor: 'normal',
            name: 'Access From',
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['80%', '95%'],
            emphasis: {
              series: 'none',
            },
            label: {
              show: true,
              position: 'center',
              formatter: () => {
                return `{text|Orçamento} \n {value| R$ 0}`;
              },
              rich: {
                text: {
                  align: 'center',
                  fontSize: filters.isMobile() ? 14 : 18,
                  padding: [0, 0, 10, 0],
                },
                value: {
                  align: 'center',
                  fontSize: filters.isMobile() ? 16 : 20,
                  fontWeight: 'bold',
                },
              },
            },
            data: [
              {
                value: 0,
                itemStyle: { color: '#ff9050' },
              },
              {
                value: 0,
                itemStyle: { color: '#e70024' },
              },
              {
                value: 0,
                itemStyle: { color: '#ffd337' },
              },
            ],
          },
        ],
      },
    });
    return { ...toRefs(state) };
  },
});
